import styled from "styled-components";
import CustomSearchField from "../../Elements/CustomViews/CustomSearchField";
import { ListHeaderContainer, StyledListHeaderContainer, StyledHeader, FilterAndButtonsContainer } from '../../../Styles/CustomViews/Pages/ListComponent/customListHeaderStyles';
import { CustomListHeaderInterface } from '../../../Models/Common/List/ListInterfaces';
import { Stack } from "@mui/material";

const CustomListHeader = (props: CustomListHeaderInterface) => {
    return <ListHeaderContainer sx={{borderColor: 'customBorder.main'}}>
        <StyledListHeaderContainer>
            <StyledHeader color="primaryText">{props.title}</StyledHeader>
            {props.subTitle}
        </StyledListHeaderContainer>
        <FilterAndButtonsContainer>
            {/* <CustomSearchField onClickSearch={() => {}}/> */}
            {props?.headerButtons && <div className="headerBtnsContainer">{props.headerButtons}</div>}
        </FilterAndButtonsContainer>
    </ListHeaderContainer>
}

export default CustomListHeader;